// 防抖,time时间内,只有最后一次有效
export const debounce = (fn, time = 100) => {
  let timer = 0;
  return function () {
	const context = this;
	let args = arguments;
	clearTimeout(timer);
	timer = window.setTimeout(() => {
	  fn.apply(context, args);
	}, time);
  };
};

// 节流,降低事件频率
export function throttle(fn, gapTime = 500) {
  let _lastTime = null;
  return function () {
	const context = this;
	let args = arguments;
	let _nowTime = +new Date();
	if (_nowTime - _lastTime > gapTime || !_lastTime) {
	  fn.apply(context, args);
	  _lastTime = _nowTime;
	}
  };
}

export const sleep = time => new Promise(resolve => setTimeout(resolve, time));

export const ellipsis = count => str =>
	str.length > count ? str.substr(0, count) + "..." : str;

export const ranger = (min, max) =>
	Math.floor(Math.random() * (max - min + 1) + min);

export const limit = (min, max) => value => Math.max(Math.min(max, value), min);

export function param2Obj(url = location.href) {
  var search = url.split("?")[1];
  if (!search) {
	return {};
  }
  //特殊处理部分querystring base64编码后出现=号导致下面转json报错
  if (search.toLowerCase().indexOf('%3d') > -1) {
	  search = search.replace('%3d', '');
	  search = search.replace('%3D', '');
  }
  const result = JSON.parse(
	  "{\"" +
	  decodeURIComponent(search)
		  .replace(/"/g, "\\\"")
		  .replace(/&/g, "\",\"")
		  .replace(/=/g, "\":\"")
		  .replace(/\+/g, " ") +
	  "\"}"
  );
  return Object.keys(result).reduce(
	  (p, k) => ({...p, [k.toLowerCase()]: result[k]}),
	  {}
  );
}

export const findParent = (vm, name) => {
  if (vm.$options.name === name) return vm;
  while ((vm = vm.$parent)) {
	if (vm.$options.name === name) return vm;
  }
  return null;
};

export const rdm = () => Math.random().toString(36).substr(2, 15);
export const chunk = chunkLength => total => Array(total).fill(0).reduce((pre, n, i) => {
  if (!(i % chunkLength)) return [...pre, [i]];
  pre.slice(-1)[0].push(i);
  return pre;
}, []);

export const chunkList = chunkLength => list => list.reduce((pre, n, i) => {
  if (!(i % chunkLength)) return [...pre, [n]];
  pre.slice(-1)[0].push(n);
  return pre;
}, []);

export const getInputValue = (id, fallback = null) => {
  try {
	const value = document.getElementById(id).value;
	return JSON.parse(value);
  } catch (e) {
	return fallback;
  }
};
